export default "__VITE_ASSET__9vbLwSJp__"